export enum FieldSourceKind {
    BeGrid = 'be-grid',
    Inline = 'inline',
}
